import { AppNode, NodeType } from "@features/builder/graph/types"
import { getItemColor } from "@features/builder/NodeDrawer/NodeForm/GraphNav/helpers"
import NodeDrawerAccordion from "@features/builder/NodeDrawer/NodeDrawerAccordion"
import { List, ListItemText } from "@mui/material"
import ListItem from "@mui/material/ListItem"
import { useNodes } from "@xyflow/react"
import { getSortedNodeLabelsById } from "@features/graph/utils/graphNodeUtils"
import { useGoToNode } from "@features/builder/hooks/useGoToNode"

export const GraphNavGroup = (props: { node: AppNode }) => {
  const nodes = useNodes<AppNode>()
  const goToNode = useGoToNode()

  const groups = props.node.type !== NodeType.Group ? props.node.data.metaNode.groups ?? [] : []
  const sortedGroupLabelsWithId = getSortedNodeLabelsById(nodes, groups)

  if (groups.length === 0) return

  return (
    <NodeDrawerAccordion id="graph-nav-groups" label="Groups:" expand={true}>
      <List sx={{ p: 0 }}>
        {sortedGroupLabelsWithId.map(({ id, label }) => (
          <ListItem
            divider
            key={id}
            onClick={() => goToNode(id)}
            sx={{
              backgroundColor: getItemColor(id),
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(225, 225, 225, 0.4)",
              },
            }}
          >
            <ListItemText primary={label} />
          </ListItem>
        ))}
      </List>
    </NodeDrawerAccordion>
  )
}
